// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__X1xdo","noInteraction":"EventWrapper_noInteraction__E5Gaj"};